import React, { useState, Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
//import {withStyles,ListItemText}  from '@material-ui/core';
import {ListItemText}  from '@material-ui/core';
import SVG from "react-inlinesvg";
import { Form,Dropdown, Button } from 'react-bootstrap'
import { UPDATE_SCENE_STATUS, DELETE_SCENE, duplicateScene, UPDATE_STATUS } from '../../../../../../../actions/sceneActions'
import { customClass } from '../../../../../../../utils'
import { toAbsoluteUrl } from '../../_helpers';
import { FontAwesomeIcon } from '../../../../../../CommonComponents/AssetsHelper';


// const styles = theme => ({
//     typography: {
//         padding: theme.spacing(2),
//     },
//     avatar: {
//         width: 18,
//         height: 18,
//         borderRadius: 'unset'
//     },
// });



const QuickActionsDropdownToggle = forwardRef((props, ref) => {
    return (
        <Button variant='link' ref={ref} href="#" onClick={e => { e.preventDefault(); props.onClick(e);}} id="kt_subheader_quick_actions">
            {""} <FontAwesomeIcon type={'solid'} icon={'ellipsis'} iconClass={'fs-2'} />
        </Button>
    );
});

//const classes = useStyles();
//export const SceneDropDownAction = ({ circleStyle }) => {
 

class SceneDropDownAction extends Component {
    state = {
        anchorEl: null,
        status: null
    }
    componentDidMount() {
        const { status } = this.props;
        this.setState({ status })
    }
    updateStatus = event => {
        const { status } = this.state;
        //const changeStatus = status=='1' ? 0 : 1;
        this.setState({ status: !status }, () => this.onStatus())
    }

    onStatus = () => {  
        const { status, anchorEl } = this.state;
        const { sceneContentId } = this.props;
        this.props.UPDATE_SCENE_STATUS(sceneContentId, status, ()=>this.callbackScene(sceneContentId))
    }

    callbackScene=(sceneID)=>{  

        const { match, scenes, studio} =this.props;
        const totalTime =scenes.scenes.filter(obj=> obj['totalTime']>0 && obj['id']!=sceneID && obj['status']==1)
       
        if((scenes.scenes.length==1 || !totalTime.length) && studio.studioWall.is_studio_enabled){
            this.props.UPDATE_STATUS(false,match.params.wallId)
          }

        setTimeout(() => this.setState({ anchorEl: null }), 1000)
    }


    onDeleteScene = event => {
        const { sceneContentId } = this.props;
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete scene now?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Back",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                 this.props.DELETE_SCENE(sceneContentId,()=>this.callbackScene(sceneContentId))
            }
            else if (result.dismiss === "cancel") {

            }
        });



    }
    onDuplicateScene = event => {
        const { sceneContentId } = this.props;
        this.props.duplicateScene(sceneContentId);
        setTimeout(() => this.setState({ anchorEl: null }), 1000)
    }
    render() {
        const { anchorEl, status } = this.state;
        let open = Boolean(anchorEl);
        // const id = open ? 'simple-popper' : undefined;
        const { wall, sceneContentId , scene} = this.props;
        return (
            <>
                <Dropdown className="dropdown-inline" drop="down" alignRight>
                    <Dropdown.Toggle
                        as={QuickActionsDropdownToggle}
                        id="dropdown-toggle-quick-actions-subheader"
                    />
                    <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi navi-hover">
                            <li className="navi-item">
                                <a href="#" className="navi-link text-dark-50" onClick={this.onDuplicateScene}>
                                    <FontAwesomeIcon type={'regular'} icon={'copy'} iconClass={'me-2 fs-6 text-gray-500'} />
                                    <span className="navi-text">Duplicate</span>
                                </a>
                            </li>
                            <li className="navi-item">
                                <a href="#" className="navi-link text-dark-50" onClick={this.onDeleteScene}>
                                    <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'me-2 fs-6 text-gray-500'} />
                                    <span className="navi-text">Delete</span>
                                </a>
                            </li>
                            <li className="navi-separator mt-3 opacity-70"></li>
                            <li className="navi-footer d-flex align-items-center px-4 py-3">
                                <ListItemText className='m-0' primary={"Enable"} />
                                <Form.Check id={`enableI`} checked={status} onClick={this.updateStatus} label="" className="enable-studio switch-sm m-0" type="switch" />
                            </li>
                        </ul>
                    </Dropdown.Menu>
                </Dropdown>
            </>

        );
    }
}
const mapStateToProps = state => {
    return {
        wall: state.wall,
        scene:state.scene,
        studio: state.studio
    }
}
const mapDispatchToProps = dispatch => {
    return {
        UPDATE_SCENE_STATUS: (sceneContentId, status, callbackScene) => dispatch(UPDATE_SCENE_STATUS(sceneContentId, status, callbackScene)),
        DELETE_SCENE: (sceneID, callbackScene) => dispatch(DELETE_SCENE(sceneID, callbackScene)),
        UPDATE_STATUS: (status,wallId) => dispatch(UPDATE_STATUS(status,wallId)),
        duplicateScene: (sceneID) => dispatch(duplicateScene(sceneID)),


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SceneDropDownAction);

//export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SceneDropDownAction));